import type { Course } from '@/lib/db/types';
import {
  CAMPUS_ORDER,
  getCourseCampus,
  getCourseComboLabel,
  groupCoursesByCampus,
  type CourseCampus,
} from '@/lib/courses/group';

interface Props {
  courses: Course[];
  value: string;
  onChange: (courseId: string) => void;
}

export function CourseTabPicker({ courses, value, onChange }: Props) {
  const grouped = groupCoursesByCampus(courses);
  const current = courses.find((c) => c.id === value);
  const campus: CourseCampus = current ? getCourseCampus(current) : 'Arlington';
  const tabs = CAMPUS_ORDER.filter((c) => c !== 'Other' && grouped[c].length > 0);
  const clubCourses = grouped[campus].length ? grouped[campus] : courses;

  const pickCampus = (next: CourseCampus) => {
    if (next === campus) return;
    const first = grouped[next][0];
    if (first) onChange(first.id);
  };

  return (
    <div>
      {tabs.length > 1 && (
        <div className="mb-2.5 flex gap-1 rounded-xl border border-line bg-cream p-1">
          {tabs.map((cl) => (
            <button
              key={cl}
              type="button"
              onClick={() => pickCampus(cl)}
              className={`flex-1 rounded-lg py-2 text-[13px] font-extrabold tracking-wide ${
                campus === cl ? 'bg-navy text-cream shadow-bt' : 'bt-flat text-ink-soft'
              }`}
            >
              {cl}
            </button>
          ))}
        </div>
      )}
      <div className="grid gap-1.5">
        {clubCourses.map((c) => {
          const selected = value === c.id;
          return (
            <button
              key={c.id}
              type="button"
              onClick={() => onChange(c.id)}
              className={`rounded-xl border px-4 py-3 text-center transition-colors ${
                selected
                  ? 'border-gold-deep bg-cream shadow-[inset_0_1px_3px_rgba(10,30,63,0.06)] ring-2 ring-gold-deep'
                  : 'border-line bg-paper hover:border-gold/50'
              }`}
            >
              <span className="block text-[15px] font-bold text-navy">{getCourseComboLabel(c)}</span>
              <span className="mt-0.5 block text-[11px] font-semibold text-mute">{c.par} par</span>
            </button>
          );
        })}
      </div>
    </div>
  );
}
